/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S3_Form_PostInputs */

const tr_iletisim_s3_form_post = /** @type {(inputs: Iletisim_S3_Form_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` üzerinden de iletebilirsiniz. Veri sorumlusu Emonse® E-Ticaret Limited Şirketi olarak başvurunuz en geç 30 gün içinde sonuçlandırılır.`)
};

const en_iletisim_s3_form_post = /** @type {(inputs: Iletisim_S3_Form_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. As the data controller, Emonse® E-Ticaret Limited Şirketi concludes your request within 30 days at the latest.`)
};

const de_iletisim_s3_form_post = /** @type {(inputs: Iletisim_S3_Form_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` einreichen. Als verantwortliche Stelle schließt Emonse® E-Ticaret Limited Şirketi Ihren Antrag spätestens innerhalb von 30 Tagen ab.`)
};

const ru_iletisim_s3_form_post = /** @type {(inputs: Iletisim_S3_Form_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Как оператор персональных данных Emonse® E-Ticaret Limited Şirketi рассматривает ваше заявление в срок не более 30 дней.`)
};

/**
* | output |
* | --- |
* | ". As the data controller, Emonse® E-Ticaret Limited Şirketi concludes your request within 30 days at the latest." |
*
* @param {Iletisim_S3_Form_PostInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s3_form_post = /** @type {((inputs?: Iletisim_S3_Form_PostInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S3_Form_PostInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s3_form_post(inputs)
	if (locale === "de") return de_iletisim_s3_form_post(inputs)
	if (locale === "ru") return ru_iletisim_s3_form_post(inputs)
	return tr_iletisim_s3_form_post(inputs)
});